export default __webpack_public_path__ + "static/media/637.39dbce27.jpg";